import buffer from "buffer";

import { Turbo } from "@hotwired/turbo-rails";
import { createInertiaApp } from "@inertiajs/vue3";
import ui from "@nuxt/ui/vue-plugin";
import _ from "lodash-es";
import { createApp, h } from "vue";
import { createI18n } from "vue-i18n";

import DefaultLayout from "../vue/layouts/DefaultLayout.vue";
import "../controllers/index";
import "./fancybox";

// Expose lodash-es as global _ for legacy Rails views
window._ = _;

if (document.querySelector('script[data-page="app"][type="application/json"]')) {
  const i18n = createI18n({
    legacy: false,
    locale: window.printavo?.currentLocale ?? "en",
    messages: window.printavo?.localeData ?? {},
  });

  createInertiaApp({
    progress: false,

    resolve: async (name) => {
      const pages = import.meta.glob("../vue/pages/**/*.vue");
      const page = await pages[`../vue/pages/${name}.vue`]();
      page.default.layout = page.default.layout || DefaultLayout;

      return page;
    },

    setup({ el, App, props, plugin }) {
      createApp({ render: () => h(App, props) })
        .use(i18n)
        .use(ui)
        .use(plugin)
        .mount(el);
    },
  });
}

Turbo.session.drive = document.querySelector("body[data-driven-by-turbo]") !== null;

// Filestack uploading buffer
window.Buffer = window.Buffer || buffer.Buffer;
